import { ClientMuteRoomResponse } from "../../proto/ClientMuteRoom_pb";
import store from "../../store";
import { updateClientMuteRoom } from "../../store/rooms/actions";
import BaseHandler from "../BaseHandler";

export default class HandleClientMuteRoomResponse extends BaseHandler<ClientMuteRoomResponse> {
  handle() {
    const clientMuteRoomResponse = this.response.toObject();
    store.dispatch(updateClientMuteRoom({ roomId: clientMuteRoomResponse.roomId, roomMute: clientMuteRoomResponse.roomMute }));
  }
}
